import React from 'react';
import { GeneralContentProps } from '../../interfaces/generalContentProps';
import { Box, Typography, Grid, useTheme, useMediaQuery } from '@mui/material';
import { GeneralContentStyles } from '../../styles/generalContent';
import { Layout08Styles } from '../../styles/layout_08';
import clsx from 'clsx';
import ReactHtmlParser from 'html-react-parser';
import { CDNImage } from '../../../common/interfaces/cdnImage';
import { appendCdnToImagePath } from '../../../common/utils/appendCdnToImagePath';

const GeneralContentLayout08 = (props: GeneralContentProps): React.JSX.Element => {
  const { titleColor, backgroundColor, backgroundImageEnabled, mediaUrl, content, title, id } = props;
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const backgroundImage = props.backgroundImage && {
    ...props.backgroundImage,
    path: appendCdnToImagePath(props.backgroundImage.path),
  };
  const { classes } = GeneralContentStyles({
    backgroundColor,
    backgroundImage: backgroundImage?.path,
    titleColor,
  });
  const { classes: layout08Classes } = Layout08Styles({
    ...props,
    backgroundImage,
  });
  const media = mediaUrl as CDNImage;

  return (
    <Box
      className={clsx({
        [classes.backgroundImage]: backgroundImageEnabled,
        [classes.bgColorContainer]: !backgroundImageEnabled,
        [classes.eventContainer]: true,
      })}
      id={id}>
      <Box>
        <Typography className={`${classes.title} ${layout08Classes.titleHeading}`}>{title}</Typography>
      </Box>
      <Grid container spacing={lgUp ? 10 : 0} className={layout08Classes.contentContainer}>
        <Grid xs={mediaUrl && lgUp ? 6 : 12} item>
          {ReactHtmlParser(content)}
        </Grid>
        {mediaUrl && (
          <Grid xs={lgUp ? 6 : 12} item className={layout08Classes.imageContainer}>
            <img className={layout08Classes.image} alt={media.name} src={appendCdnToImagePath(media.path)} />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default GeneralContentLayout08;
